/**
 * The renderer's words for a report (`kind: report`, docs/ui-components.md §7.1): its parameter bar,
 * the column of lines, the comparison's difference, and what it says while nothing is asked yet.
 * Kept beside the catalogue and spread into it, so a parallel change to the catalogue does not
 * collide with these.
 */
export const REPORT_EN = {
    'report.params': 'What the report is for',
    'report.apply': 'Apply',
    'report.line': 'Line',
    'report.variance': 'Difference',
    'report.asOf': 'As of {at}',
    'report.empty': 'Nothing to report for what was chosen.',
    'report.chart.caption': '{title}: a chart of the table below, which holds the same figures',
    'report.missing.title': 'Choose {names} to see the report',
    'report.missing.description': 'The report is worked out for what you choose above; nothing is asked until then.',
    'report.malformed': 'The server answered with something that is not a report.',
    'report.range.from': 'From',
    'report.range.to': 'To',
    'report.period.length': 'Length',
    'report.period.year': 'Year',
    'report.period.part': 'Which',
    'report.period.month': 'Month',
    'report.period.quarter': 'Quarter',
    'report.period.whole': 'Year',
    'report.period.q': 'Q{n}',
    'report.export.csv': 'CSV file',
    'report.export.xlsx': 'Excel workbook',
    'report.export.pdf': 'Print or save as PDF',
    'report.export.docx': 'Word document',
};
export const REPORT_AR = {
    'report.params': 'ما يُعدّ له التقرير',
    'report.apply': 'تطبيق',
    'report.line': 'البند',
    'report.variance': 'الفرق',
    'report.asOf': 'حتى {at}',
    'report.empty': 'لا شيء في التقرير لما اخترته.',
    'report.chart.caption': '{title}: رسمٌ للجدول أدناه، وفيه الأرقام نفسها',
    'report.missing.title': 'اختر {names} لعرض التقرير',
    'report.missing.description': 'يُعدّ التقرير لما تختاره في الأعلى؛ ولا يُطلب شيء قبل ذلك.',
    'report.malformed': 'أجاب الخادم بشيء ليس تقريراً.',
    'report.range.from': 'من',
    'report.range.to': 'إلى',
    'report.period.length': 'المدة',
    'report.period.year': 'السنة',
    'report.period.part': 'أيّها',
    'report.period.month': 'شهر',
    'report.period.quarter': 'ربع سنة',
    'report.period.whole': 'سنة',
    'report.period.q': 'الربع {n}',
    'report.export.csv': 'ملف CSV',
    'report.export.xlsx': 'مصنّف Excel',
    'report.export.pdf': 'طباعة أو حفظ PDF',
    'report.export.docx': 'مستند Word',
};
//# sourceMappingURL=i18n-report.js.map